import { BaseResponse } from './base-response.model';

export interface PreCannedReportsResonse extends BaseResponse {
	message: string;
	reports: PreCannedReportJSON[];
}

export interface PreCannedReportJSON {
	id: number;
	name: string;
	procName: string;
	folderId: number;
	explanation: string;
	reportGroup: number;
	sortOrder: number;
	runReport: string;
	autoExecute: number;
	parameterHelp: string;
	exportType: string;
	icon: string;
}

export class PreCannedReport {
	constructor(
		public id: number,
		public name: string,
		public procName: string,
		public folderId: number,
		public explanation: string,
		public reportGroup: number,
		public sortOrder: number,
		public runReport: string,
		public autoExecute: number,
		public parameterHelp: string,
		public exportType: string,
		public icon: string
	) {}

	static fromJSON(json: PreCannedReportJSON): PreCannedReport {
		return Object.assign(
			Object.create(PreCannedReport.prototype),
			json,
			{}
		);
	}
}
